<template>
  <div ref="monitoringContent" class="auxiliary-control container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--卡片数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="数据列表" name="0">
            <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleFormQuery()">
              <el-form-item label="信号种类">
                <el-checkbox-group v-model="checkedResourceKindIds">
                  <el-checkbox v-for="resourceKind in controlResourceKinds" :key="resourceKind.id" :label="resourceKind.id">
                    {{resourceKind.name}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleFormQuery()" type="primary">刷 新</el-button>
                <el-button @click="resetQueryForm()">重 置</el-button>
              </el-form-item>
              <el-form-item style="float:right">
                <span>总数</span><el-badge class="mark" :value="pageTotalCount" type="primary"/>
                <span>在线</span><el-badge class="mark" :value="pageOnlineCount" type="warning"/>
                <span>离线</span><el-badge class="mark" :value="pageOfflineCount" type="info"/>
              </el-form-item>
            </el-form>
            <div class="general-container">
              <div class="card-container">
                <!--最大为4行-->
                <el-row style="margin-bottom: 20px" v-for="(rowItem, rowIndex) in cardMaxRowCount" :key="rowItem">
                  <!--每行3或4列-->
                  <el-col :span="24/cardMaxColCount" v-for="(colItem, colIndex) in cardMaxColCount" :key="colItem" :offset="0">
                    <el-card class="node-card" v-show="rowIndex*cardMaxColCount + colIndex < cardData.length">
                      <div slot="header" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;">
                        <span class="card-header-title" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardCurrentItem === cardData[rowIndex*cardMaxColCount + colIndex] ? 'active':''">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].name : ''}}
                        </span>
                        <!--<el-button style="float: right;width:50px" type="text" @click="handleControlNodeView(cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null)">查看</el-button>-->
                      </div>
                      <div class="card-body-content" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null">
                        <div class="control-container">
                          <img class="control-icon" :src="controlNodeImageFileNames[rowIndex*cardMaxColCount + colIndex]" />
                          <!--信号量输出开关按钮-->
                          <el-switch v-if="cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].resourceKind===24:true" class="switch-button" :active-value="1" :inactive-value="0" v-model="inputControlNodeControlStates[rowIndex*cardMaxColCount + colIndex]" @change="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleControlStateChange();"></el-switch>
                          <!--模拟量输出计数器和按钮-->
                          <el-input-number v-if="cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].resourceKind===25:false" v-model="inputControlNodeControlStates[rowIndex*cardMaxColCount + colIndex]" size="mini" controls-position="right" :precision="1" :step="1" :max="100" style="margin-left:55px;width:100px"></el-input-number>
                          <el-button v-if="cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].resourceKind===25:false" class="adjust-button" size="mini" type="primary" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleAdjustValue();">调 整</el-button>
                        </div>
                        <div class="status-container">
                          <div style="display: inline-block; min-width:64px;">
                            <div class="label-text">节点类型</div>
                            <div class="value-text name">
                              {{ cardData.length > rowIndex*cardMaxColCount + colIndex ? $type.getResourceSubTypeNameById(cardData[rowIndex*cardMaxColCount + colIndex].resourceKind, cardData[rowIndex*cardMaxColCount + colIndex].controlledObjectKind) : ''}}
                            </div>
                          </div>
                          <div class="right-vertical-line"></div>
                          <div style="display: inline-block">
                            <div class="label-text">连接状态</div>
                            <div class="value-text" :class="cardData.length > rowIndex*cardMaxColCount + colIndex ? colorClassFromResourceOnlineState(0, cardData[rowIndex*cardMaxColCount + colIndex].encoderAlarmState, cardData[rowIndex*cardMaxColCount + colIndex].encoderEventTypeSet, 0, 0) :''">
                              {{cardData.length > rowIndex*cardMaxColCount + colIndex ? $type.getResourceOnlineState(0, cardData[rowIndex*cardMaxColCount + colIndex].encoderAlarmState, cardData[rowIndex*cardMaxColCount + colIndex].encoderEventTypeSet, 0, 0) === 1 ? '在线':'离线' :''}}
                            </div>
                          </div>
                          <div class="right-vertical-line"></div>
                          <div style="display: inline-block">
                            <div class="label-text">运行状态</div>
                            <div class="value-text" :class="cardData.length > rowIndex*cardMaxColCount + colIndex ? colorClassFromResourceControlValue(cardData[rowIndex*cardMaxColCount + colIndex].resourceKind, cardData[rowIndex*cardMaxColCount + colIndex].controlValue, cardData[rowIndex*cardMaxColCount + colIndex].valueType) :''">
                              {{ cardData.length > rowIndex*cardMaxColCount + colIndex ? $type.getResourceControlStateText(cardData[rowIndex*cardMaxColCount + colIndex].resourceKind, cardData[rowIndex*cardMaxColCount + colIndex].controlledObjectKind, cardData[rowIndex*cardMaxColCount + colIndex].controlValue,
                              cardData[rowIndex*cardMaxColCount + colIndex].valueType, cardData[rowIndex*cardMaxColCount + colIndex].dataNodeDecimalDigit, cardData[rowIndex*cardMaxColCount + colIndex].dataNodeDataUnit) : ''}}
                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="card-body-footer">
                        <div class="button-container">
                          <el-button type="primary" class="footer-button" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleDeploy();">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].deployed ? '撤防':'布防'}}
                          </el-button>
                          <el-button type="danger" class="footer-button" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleCancelAlarm();">
                          消警
                          </el-button>
                        </div>
                      </div>-->
                    </el-card>
                  </el-col>
                </el-row>
              </div>
              <el-pagination v-show="cardTotalItem > cardQueryParams.pageSize"
                background
                @current-change="handleCurrentPageChange"
                :current-page.sync="cardQueryParams.pageNum"
                :page-size.sync="cardQueryParams.pageSize"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next, jumper"
                :total="cardTotalItem">
              </el-pagination>
              <div class="node-control-bar" :class="!footerOpen ? 'node-control-bar-side-close' : ''">
                <div class="node-control-bar-toggle-btn" @click="toggleFooter"></div>
                <div class="node-control-bar-left">
                  <a @click="handleControlStateChange" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon" :class="cardCurrentItem != null && cardCurrentItem.controlState === 0 ? 'open':'close'"></span>{{cardCurrentItem != null && cardCurrentItem.controlState === 1 ? '关闭':'打开'}}
                  </a>
                  <a @click="handleOpenAll" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon open-all"></span>全打开
                  </a>
                  <a @click="handleCloseAll" href="javascript:;" class="node-control-bar-control-btn">
                    <span class="button_icon close-all"></span>全关闭
                  </a>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="组态画面" name="1">
            <map-navigator
              :defaultMapId="mapQueryParams.mapId"
              :defaultRegionId="mapQueryParams.regionId"
              :defaultSystemKind="mapQueryParams.systemKind"
              :mapNodeBySystemKindFiltered="false"
              ref="mapNavigator"
            >
            </map-navigator>
          </el-tab-pane>
<!--          <el-tab-pane label="事件记录" name="2">-->
<!--            <el-form ref="eventQueryForm" class="pagination-table-query-form" :inline="true"-->
<!--                     @keyup.enter.native="handleEventFormQuery()">-->
<!--              <el-form-item label="告警状态" class="right-vertical-line pr15">-->
<!--                <el-checkbox-group v-model="eventTableQueryParams.alarmStates">-->
<!--                  <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">-->
<!--                    {{alarmState.name}}-->
<!--                  </el-checkbox>-->
<!--                </el-checkbox-group>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="事件触发时间">-->
<!--                <uni-date-range-picker-->
<!--                  v-model="eventDates"-->
<!--                  type="daterange"-->
<!--                  range-separator="至"-->
<!--                  start-placeholder="开始日期"-->
<!--                  end-placeholder="结束日期">-->
<!--                </uni-date-range-picker>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-button @click="handleEventFormQuery()" type="primary">查 询</el-button>-->
<!--                <el-button @click="resetEventQueryForm()">重 置</el-button>-->
<!--              </el-form-item>-->
<!--            </el-form>-->
<!--            <div class="pagination-table-container">-->
<!--              <el-table :data="eventTableData"-->
<!--                        ref="eventTable"-->
<!--                        border highlight-current-row-->
<!--                        element-loading-background="rgba(255, 255, 255, 0.8)"-->
<!--                        element-loading-spinner="el-icon-loading"-->
<!--                        element-loading-text="努力加载中..."-->
<!--                        style="width: 100%">-->
<!--                &lt;!&ndash;          <el-table-column type="selection" width="40"></el-table-column>&ndash;&gt;-->
<!--                <el-table-column label="序号" type="index" width="60"></el-table-column>-->
<!--                <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">-->
<!--                  <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>-->
<!--                <el-table-column label="告警状态" prop="alarmState" width="80">-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-tag :type="scope.row.alarmState === 1 ? 'danger'-->
<!--                  : scope.row.alarmState === 2 ? 'warning'-->
<!--                  :'primary'">-->
<!--                      {{getNameById(scope.row.alarmState, $type.alarmStates)}}-->
<!--                    </el-tag>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="告警级别" prop="alarmLevel" width="100">-->
<!--                  <template slot-scope="scope">{{ getNameById(scope.row.alarmLevel, $type.alarmLevels) }}</template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>-->
<!--                <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>-->
<!--                <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>-->
<!--                <el-table-column label="事件触发时间" prop="happenTime" width="160">-->
<!--                  <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="数值范围" prop="alarmRuleText" width="120"></el-table-column>-->
<!--                <el-table-column label="操作" width="100">-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-button-->
<!--                      class="col-btn"-->
<!--                      type="text"-->
<!--                      icon="el-icon-view"-->
<!--                      @click="handleEventView(scope.row)"-->
<!--                    >查看-->
<!--                    </el-button>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--              </el-table>-->
<!--              <el-pagination v-show="eventTableTotalRow > eventTableQueryParams.pageSize"-->
<!--                             background-->
<!--                             @current-change="handleEventCurrentPageChange"-->
<!--                             @size-change="handleEventPageSizeChange"-->
<!--                             :current-page.sync="eventTableQueryParams.pageNum"-->
<!--                             :page-sizes="[5, 10, 15, 20, 30, 50, 100]"-->
<!--                             :page-size.sync="eventTableQueryParams.pageSize"-->
<!--                             prev-text="上一页"-->
<!--                             next-text="下一页"-->
<!--                             layout="total, sizes, prev, pager, next, jumper"-->
<!--                             :total="eventTableTotalRow">-->
<!--              </el-pagination>-->
<!--            </div>-->
<!--          </el-tab-pane>-->
<!--          <el-tab-pane label="统计分析" name="3">-->
<!--            <el-row type="flex">-->
<!--              <el-col class="chart-container" :span="24">-->
<!--                <div class="chart-title">告警次数排行</div>-->
<!--                <bar-->
<!--                  ref="alarmEventCountRankingBar"-->
<!--                  :id="alarmEventCountRankingBarId"-->
<!--                  :source="alarmEventCountRankingBarData"-->
<!--                  :color="alarmEventCountRankingBarColor"-->
<!--                  style="width:100%; height:240px"-->
<!--                ></bar>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row type="flex">-->
<!--              <el-col class="chart-container" :span="24">-->
<!--                <div class="chart-title">电量排行</div>-->
<!--                <bar-->
<!--                  ref="temperatureValueRankingBar"-->
<!--                  :id="temperatureValueRankingBarId"-->
<!--                  :source="temperatureValueRankingBarData"-->
<!--                  :color="temperatureValueRankingBarColor"-->
<!--                  style="width:100%; height:240px"-->
<!--                ></bar>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row type="flex">-->
<!--              <el-col class="chart-container" :span="24">-->
<!--                <div class="chart-title">功率排行</div>-->
<!--                <bar-->
<!--                  ref="humidityValueRankingBar"-->
<!--                  :id="humidityValueRankingBarId"-->
<!--                  :source="humidityValueRankingBarData"-->
<!--                  :color="humidityValueRankingBarColor"-->
<!--                  style="width:100%; height:240px"-->
<!--                ></bar>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>

    <!--显示数据节点信息-->
    <show-data-node v-if="showControlNodeModalOpen" :modalOpen="showControlNodeModalOpen" :dataNode="cardCurrentItem" @cancel="handleShowControlNodeModalCancel"></show-data-node>

  </div>
</template>

<script type="text/ecmascript-6">
import AuxiliaryControl from './AuxiliaryControl.js'

export default AuxiliaryControl
</script>

<style lang="scss">
  @import "AuxiliaryControl.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/auxiliaryControl/AuxiliaryControl.vue